import { render, staticRenderFns } from "./manage-card.vue?vue&type=template&id=36d776bf&scoped=true&"
import script from "./manage-card.vue?vue&type=script&lang=js&"
export * from "./manage-card.vue?vue&type=script&lang=js&"
import style0 from "./manage-card.vue?vue&type=style&index=0&id=36d776bf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d776bf",
  null
  
)

export default component.exports